import { makeEntityScaffold } from '@classpass/saga-tools';

import URLS from 'constants/urls';

const handler = ({ httpClient }, newPassword) =>
  httpClient.post(URLS.user.changePassword, {
    password: newPassword,
    repeat_password: newPassword,
  });

export default makeEntityScaffold('SAGA.API.UPDATE_PASSWORD', handler);
